import { defineComponent } from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import {
  AutoOnboardActions,
  AutoOnboardMutations,
  AutoOnboardState
} from '~/store/owner/autoOnboard'
import { AutoOnboardEvent } from '~/types/types'

export default defineComponent({
  name: 'AutoOnboardMixin',

  computed: {
    ...(mapState<AutoOnboardState>('owner/autoOnboard', {
      onboardableRepositories: (state: AutoOnboardState) => state.onboardableRepositories,
      hasMoreReposToOnboard: (state: AutoOnboardState) => state.hasMoreReposToOnboard,
      selectedTemplate: (state: AutoOnboardState) => state.selectedTemplate,
      configTemplate: (state: AutoOnboardState) => state.configTemplate,
      autoOnboardEvents: (state: AutoOnboardState) => state.autoOnboardEvents,
      configTemplateList: (state: AutoOnboardState) => state.configTemplateList,
      totalTemplates: (state: AutoOnboardState) => state.totalTemplates
    }) as {
      onboardableRepositories: () => AutoOnboardState['onboardableRepositories']
      hasMoreReposToOnboard: () => AutoOnboardState['hasMoreReposToOnboard']
      selectedTemplate: () => AutoOnboardState['selectedTemplate']
      configTemplate: () => AutoOnboardState['configTemplate']
      autoOnboardEvents: () => AutoOnboardState['autoOnboardEvents']
      configTemplateList: () => AutoOnboardState['configTemplateList']
      totalTemplates: () => AutoOnboardState['totalTemplates']
    }),

    sortedEvents(): AutoOnboardEvent[] {
      const sortOrder = ['OPEN', 'PEND']
      return this.autoOnboardEvents
        .filter((event) => sortOrder.includes(event.status))
        .sort((currentEvent, next) =>
          sortOrder.indexOf(currentEvent.status) < sortOrder.indexOf(next.status) ? -1 : 1
        )
    },
    hasAutoOnboardEvents(): boolean {
      return this.sortedEvents.length > 0
    }
  },

  methods: {
    ...mapActions('owner/autoOnboard', {
      fetchAutoOnboardableRepoList: AutoOnboardActions.FETCH_AUTO_ONBOARDABLE_REPO_LIST,
      createConfigTemplate: AutoOnboardActions.CREATE_TEMPLATE,
      updateConfigTemplate: AutoOnboardActions.UPDATE_TEMPLATE,
      deleteConfigTemplate: AutoOnboardActions.DELETE_TEMPLATE,
      fetchSingleTemplate: AutoOnboardActions.FETCH_SINGLE_TEMPLATE,
      fetchOnboardingEventList: AutoOnboardActions.FETCH_ONBOARDING_EVENT_LIST,
      fetchConfigTemplatesList: AutoOnboardActions.FETCH_TEMPLATES,
      startOnboarding: AutoOnboardActions.START_ONBOARDING
    }),

    ...mapMutations('owner/autoOnboard', {
      selectTemplateToOnboard: AutoOnboardMutations.SELECT_TEMPLATE_TO_ONBOARD,
      resetOnboardableReposList: AutoOnboardMutations.RESET_ONBOARDABLE_REPO_LIST,
      resetConfigTemplate: AutoOnboardMutations.RESET_CONFIG_TEMPLATE
    }),

    async refetchTemplateList(provider?: string, owner?: string): Promise<void> {
      provider = provider ?? this.$route.params.provider
      owner = owner ?? this.$route.params.owner

      await this.fetchConfigTemplatesList({
        provider,
        login: owner,
        limit: 25,
        currentPage: 1,
        refetch: true,
        commit: true
      })
    }
  }
})
